module.exports = __webpack_public_path__ + "img/Hiking001.2b19e972.jpg";